
import { updateAppConfig } from '#app'
import { defuFn } from '/var/jenkins_home/workspace/qboson-web/node_modules/.pnpm/defu@6.1.4/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "4681bbe1-a9fb-4c63-9f98-e22a117229ba"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/var/jenkins_home/workspace/qboson-web/app/app.config.ts"
import cfg1 from "/var/jenkins_home/workspace/qboson-web/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, cfg1, inlineConfig)
